module.exports = __webpack_public_path__ + "img/cluster-28-advert.9b88aab2.svg";